<template>
	<div>
		Ansættelse <span class="delete" @click="$emit('remove')">slet</span>
		<div class="form">
			<date-select-view label="Fra" v-model="_from" :controller="$store.state.popupController" />
			<date-select-view label="Til" v-model="_to" :controller="$store.state.popupController" :optional="open" />
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: Object,
				required: true,
			},
			open: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			_from: {
				set: function (value) {
					this.$emit('input', {
						from: value,
						to: this.value.to
					});
				},
				get: function () {
					return this.value.from;
				}
			},
			_to: {
				set: function (value) {
					this.$emit('input', {
						from: this.value.from,
						to: value
					});
				},
				get: function () {
					return this.value.to;
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.form {
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: 20px;

		padding: 20px 0 20px 0;
	}

	.delete {
		color: #f7223f;
		cursor: pointer;
	}
</style>